// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.checkbox:hover .checkbox__indicator {
  box-shadow: 0px 0px 5px #0abf53;
}

.checkbox__text.disabled {
  opacity: 0.7;
}

.checkbox__input {
  display: none;
}
.checkbox__input:checked ~ .checkbox__indicator {
  border-color: #0abf53;
  background-color: rgb(203.6865671642, 252.3134328358, 223.2985074627);
}
.checkbox__input:checked ~ .checkbox__indicator:before {
  transform: rotate(-45deg) translate(-1px, 9px) scale(1);
}

.checkbox__indicator {
  width: 24px;
  height: 24px;
  display: inline-block;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-right: 8px;
}
.checkbox__indicator:before {
  content: "";
  display: block;
  width: 10px;
  height: 5px;
  border-left: 3px solid #0abf53;
  border-bottom: 3px solid #0abf53;
  transform: rotate(-45deg) translate(-1px, 9px) scale(0);
  transition: all 0.3s;
}`, "",{"version":3,"sources":["webpack://./src/components/Checkbox/Checkbox.scss","webpack://./src/utils/scss/_variables.scss"],"names":[],"mappings":"AAEA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;AADF;AAII;EACE,+BAAA;AAFN;;AAOE;EACE,YAAA;AAJJ;;AAQA;EACE,aAAA;AALF;AAOE;EACE,qBCvBY;EDwBZ,qEAAA;AALJ;AAOI;EACE,uDAAA;AALN;;AAUA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;AAPF;AASE;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,8BAAA;EACA,gCAAA;EACA,uDAAA;EACA,oBAAA;AAPJ","sourcesContent":["@import \"./../../utils/scss/variables\";\n\n.checkbox {\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n\n  &:hover {\n    .checkbox__indicator {\n      box-shadow: 0px 0px 5px $primary-color;\n    }\n  }\n}\n.checkbox__text {\n  &.disabled {\n    opacity: 0.7;\n  }\n}\n\n.checkbox__input {\n  display: none;\n\n  &:checked ~ .checkbox__indicator {\n    border-color: $primary-color;\n    background-color: lighten($primary-color, 50);\n\n    &:before {\n      transform: rotate(-45deg) translate(-1px, 9px) scale(1);\n    }\n  }\n}\n\n.checkbox__indicator {\n  width: 24px;\n  height: 24px;\n  display: inline-block;\n  border-radius: 3px;\n  border: 1px solid #ccc;\n  margin-right: 8px;\n\n  &:before {\n    content: \"\";\n    display: block;\n    width: 10px;\n    height: 5px;\n    border-left: 3px solid $primary-color;\n    border-bottom: 3px solid $primary-color;\n    transform: rotate(-45deg) translate(-1px, 9px) scale(0);\n    transition: all 0.3s;\n  }\n}\n","$primary-color: #0abf53;\n\n// Screen size variables\n$screen-xxs-max: 370px; // Tiny phones\n$screen-xs-max: 425px; // Tiny phones\n$screen-sm-max: 576px; // Small tablets and large smartphones (landscape view)\n$screen-md-max: 767px; // Small tablets (portrait view)\n$screen-lg-max: 1024px; // Tablets and small desktops\n$screen-upper-lg-max: 1120px; // Tablets and small desktops\n$screen-xl-max: 1440px; // Large tablets and desktops\n\n// z-index\n$z-indexes: (\"login\", \"loginFooter\", \"loginOverlay\");\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
